// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__QSrrL","col":"styles_col__1bvyS","actions":"styles_actions__2LEKP","conflict":"styles_conflict__2dmTN"};